<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <select
    [(ngModel)]="selectedChildStatus"
    (change)="onSearch()"
    class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
  >
    <option [ngValue]="undefined">Select Child Status</option>
    <option *ngFor="let type of childStatus" [ngValue]="type">
      {{ type }}
    </option>
  </select>
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="parentInsider"
    type="text"
    placeholder="Search by parent insider name"
    class="border-b min-w-60 border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'parentInsider')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="childInsider"
    type="text"
    placeholder="Search by child insider name"
    class="border-b min-w-60 border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'childInsider')"
  />
</div>
<div class="mb-4">
  <p-table
    [value]="processedInsiderRelationship"
    [paginator]="processedInsiderRelationship.length > 0"
    [first]="first"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [rows]="paginator.pageSize"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '40rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="pageChange($event)"
    [(selection)]="selectedSecurity"
    dataKey="asReportedSecurityId"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template #header>
      <tr>
        <th>Insider Relationship Id</th>
        <th>Parent Insider Id</th>
        <th>Parent Insider Name</th>
        <th>Child Insider Id</th>
        <th>Child Insider Name</th>
        <th>Insider Relationship</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #body let-insider>
      <tr>
        <td>
          {{ insider.insiderRelationshipId || "N/A" }}
        </td>
        <td>{{ insider.parentInsiderId || "N/A" }}</td>
        <td>
          {{ insider.parentInsiderName || "N/A" }}
        </td>
        <td>{{ insider.childInsiderId || "N/A" }}</td>
        <td>
          {{ insider.childInsiderName || "N/A" }}
        </td>
        <td>
          {{ insider.reason || "N/A" }}
        </td>
        <td>
          <button
            (click)="onRemapClick(insider, $event)"
            class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          >
            Remap
          </button>
          <button
            (click)="onUpdateClick(insider, $event)"
            class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          >
            Update
          </button>
          <button
            (click)="onRemoveClick(insider)"
            class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          >
            Delete
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-container *ngIf="!isLoading && processedInsiderRelationship.length === 0">
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-container>
<p-confirmDialog key="relation-confirm"></p-confirmDialog>
<p-toast></p-toast>
